export default "__VITE_ASSET__DuH3oRx8__"